import { render, staticRenderFns } from "./PatentNoteForm.vue?vue&type=template&id=51311f82&"
import script from "./PatentNoteForm.vue?vue&type=script&lang=js&"
export * from "./PatentNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentNoteForm.vue?vue&type=style&index=0&id=51311f82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports